<template>
  <div class="healthPage">
    <div>
      <van-icon name="arrow-left" size="22" @click="goHome" />
    </div>
    <div class="bg-img">
      <div class="bg-font">填写健康档案</div>
    </div>

    <div class="name">
      <div class="name-font">姓名</div>
      <input type="text" placeholder="请填写您的姓名" style="color: #333333" :value="userName" @input="change" />
    </div>
    <!--    生日-性别-->
    <div class="birthday-sex">
      <div class="birthday" @click="popupOut">
        <div>生日</div>
        <div style="display: flex">
          <input class="birthday-input" placeholder="请选择" :value="timer" readonly="readonly" />
          <van-icon name="arrow-down" class="bir-icon" />
        </div>
      </div>

      <div class="sex" @click="sexOut = true">
        <div>性别</div>
        <div style="display: flex">
          <input class="birthday-input" placeholder="请选择" :value="sex" readonly="readonly" />
          <van-icon name="arrow-down" class="bir-icon" />
        </div>
      </div>
    </div>

    <!--    身高体重-->
    <div style="display: flex; justify-content: space-between" class="height">
      <div>
        <inputBox title="身高" company="cm" :inputValue="userHeight" @input="getUserHeight"></inputBox>
      </div>
      <div>
        <inputBox title="体重" company="kg" :inputValue="userWeight" @input="getUserWeight"></inputBox>
      </div>
    </div>

    <!--    腰围臀围-->
    <div style="display: flex; justify-content: space-between" class="height">
      <div>
        <inputBox title="腰围" company="cm" :inputValue="userYaowei" @input="getUserYaowei"></inputBox>
      </div>
      <div>
        <inputBox title="臀围" company="cm" :inputValue="userTunwei" @input="getUserTunwei"></inputBox>
      </div>
    </div>

    <div class="btn" @click="throttle(submit, 2000)">保存</div>
    <div class="btn-2" @click="$router.push('/')" v-if="show == 1">先跳过</div>
    <!--    年月日弹出层-->
    <van-popup v-model="out" class="out" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="cancel"
        @confirm="confirm"
      />
    </van-popup>
    <!--    性别选择器弹出层-->
    <van-popup v-model="sexOut" class="out" position="bottom">
      <van-picker
        title="请选择性别"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
        v-model="sex"
      />
    </van-popup>
  </div>
</template>

<script>
let flag;
import inputBox from "../components/input";
import { getUserHealth, EditUserHealth } from "@/service/api";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "health",
  components: {
    inputBox,
  },
  data() {
    return {
      userYaowei: "",
      userTunwei: "",
      userWeight: "",
      userHeight: "",
      userName: "",
      show: "",
      // maxDate:new Date(2022,11,31),
      maxDate: new Date(),
      minDate: new Date(1900, 1, 1),
      currentDate: new Date(),
      timer: "",
      sex: "",
      sexData: "",
      out: false,
      sexOut: false,
      columns: ["男", "女"],
    };
  },
  methods: {
    userHealth() {
      getUserHealth()
        .then((res) => {
          this.timer = res.data.birth;
          this.userName = res.data.name;
          if (res.data.sex == 1) {
            this.sex = "男";
            this.sexData = 1;
          } else if (res.data.sex == 2) {
            this.sex = "女";
            this.sexData = 2;
          } else {
            this.sex = "";
            this.sexData = 0;
          }
          this.userYaowei = res.data.waistline;
          this.userWeight = res.data.weight;
          this.userHeight = res.data.height;
          this.userTunwei = res.data.hipline;
        })
        .catch((err) => {
          this.$toast("请先完成登录", err);
        });
    },
    throttle(func, wait = 500, immediate = true) {
      if (immediate) {
        if (!flag) {
          flag = true;
          // 如果是立即执行，则在wait毫秒内开始时执行
          typeof func === "function" && func();
          setTimeout(() => {
            flag = false;
          }, wait);
        }
      } else {
        if (!flag) {
          flag = true;
          // 如果是非立即执行，则在wait毫秒内的结束处执行
          setTimeout(() => {
            flag = false;
            typeof func === "function" && func();
          }, wait);
        }
      }
    },
    getUserTunwei(key) {
      this.userTunwei = key;
    },
    getUserYaowei(key) {
      this.userYaowei = key;
    },
    getUserWeight(key) {
      this.userWeight = key;
    },
    getUserHeight(key) {
      this.userHeight = key;
    },
    change(e) {
      this.userName = e.target.value;
    },
    submit() {
      if (this.timer != "" && this.sexData != "" && this.userHeight != "" && this.userWeight != "") {
        const obj = {
          name: this.userName,
          birth: this.timer,
          sex: this.sexData,
          height: this.userHeight,
          weight: this.userWeight,
          waistline: this.userYaowei,
          hipline: this.userTunwei,
        };
        EditUserHealth(obj)
          .then((res) => {
            this.$toast(res.msg);
            this.$router.push("/");
          })
          .catch((err) => {
            this.$toast(err.message);
          });
      } else if (this.timer == "") {
        this.$toast("请先选择出生年月");
      } else if (this.sexData == "") {
        this.$toast("请先选择性别");
      } else if (this.userHeight == "") {
        this.$toast("请先输入身高");
      } else if (this.userWeight == "") {
        this.$toast("请先输入体重");
      }
    },
    onCancel() {
      this.sexOut = false;
    },
    onConfirm(v, index) {
      this.sex = v;
      if (index == 0) {
        this.sexData = "1";
      } else if (index == 1) {
        this.sexData = "2";
      } else {
        this.sexData = "0";
      }
      this.sexOut = false;
    },
    timeFormat(time) {
      // 时间格式化 2019-9-8
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      // return year + '年' + month + '月' + day + '日'
      return year + "-" + month + "-" + day;
    },
    confirm() {
      console.log(this.currentDate);
      this.timer = this.timeFormat(this.currentDate);
      console.log(this.timer);
      this.out = false;
    },
    cancel() {
      this.out = false;
    },
    goHome() {
      this.$router.push("/");
    },
    popupOut() {
      this.out = true;
    },
  },
  created() {
    this.show = this.$route.query.show;
    this.userHealth();
  },
};
</script>

<style scoped lang="scss">
.healthPage {
  padding: 16px;
  background: #fefffe;
  .bg-img {
    margin-top: 28px;
    width: 343px;
    height: 94px;
    background: url("../assets/imgs/bg-img@2x.png") no-repeat 100% 100%;
    -webkit-background-size: 100% auto;
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #222222;
    line-height: 32px;
    .bg-font {
      margin-top: 8px;
      margin-left: 8px;
    }
  }
  .name {
    width: 327px;
    height: 60px;
    margin: -21px auto 0 auto;
    .name-font {
      font-size: 13px;
      font-weight: 500;
      text-align: left;
      color: #333333;
      line-height: 18px;
    }
    input {
      font-size: 14px;
      font-weight: 400;
      /*text-align: left;*/
      color: #b4b4b4;
      line-height: 21px;
      width: 100%;
      height: 37px;
      border-style: none;
      /*outline-style: none;*/
      border-bottom: 0.5px solid #dcdcdc;
    }
  }
  .birthday-sex {
    margin-top: 30px;
    margin-left: 8px;
    /*width: 100%;*/
    height: 62px;
    display: flex;
    justify-content: space-between;
    .bir-icon {
      line-height: 39px;
    }
    .birthday {
      width: 144px;
      height: 62px;
      font-weight: 500;
      text-align: left;
      color: #333333;
      font-size: 13px;
      display: flex;
      flex-direction: column;
    }
    .birthday-input {
      height: 39px;
      width: 110px;
      border-style: none;
      border-bottom: 0.5px solid #dcdcdc;
    }
    .sex {
      width: 144px;
      height: 62px;
      margin-right: 8px;
      /*background: pink;*/
      font-weight: 500;
      text-align: left;
      color: #333333;
      font-size: 13px;
    }
  }
  .height {
    margin-left: 8px;
    margin-top: 30px;
  }
  .btn {
    width: 327px;
    height: 44px;
    background: #224a91;
    border-radius: 4px;
    margin: 40px auto 0 auto;
    text-align: center;
    line-height: 44px;
    color: #fefffe;
    font-size: 15px;
    font-weight: 500;
  }
  .btn-2 {
    margin: 24px auto 0 auto;
    width: 63px;
    height: 28px;
    opacity: 0.2;
    background: #cccccc;
    border-radius: 14px;
    text-align: center;
    line-height: 28px;

    font-size: 13px;
    font-weight: 400;
  }
  .out {
    /*width: 100%;*/
    /*margin-bottom: ;*/
    /*height: 100%;*/
  }
}
</style>
